const UiTablePropsOption2 = {
  //* 表格数据源
  data: { type: Array, required: true },
  //* 无数据时的提示文本
  error: { type: String, default: "" },
  //* 表格高度, 超出高度将出现滚动条
  height: { type: Number },
  //* 表格配置项
  option: { type: Array, required: true },
  //* 表格两侧间距
  spacing: { type: [String, Number], default: 0 },
  //* 表格选择功能
  selector: { type: String },
  //* 表格宽度溢出
  overflow: { type: Boolean, default: false }
};
const UiTableEmits2 = {
  sort: (_result) => true,
  //* 排序
  radio: (_data) => true,
  //* 单选
  checkbox: (_data) => true
  //* 复选
};

export { UiTableEmits2, UiTablePropsOption2 };
//# sourceMappingURL=component.mjs.map
